<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ $route.params.id ? 'Editar' : 'Adicionar' }} Grupo
              </div>
            </div>

            <div class="card-body">
              <hr />
              <br />

              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent="save">
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="groupName">
                          <span class="required">*</span> Nome do Grupo:
                        </label>

                        <input
                          autocomplete="off"
                          type="text"
                          id="groupName"
                          class="form-control"
                          v-model="group.group_nome"
                          placeholder="Digite o nome do grupo"
                        />
                      </div>

                      <div class="form-group col-md-3">
                        <label for="companySelect">
                          <span class="required">*</span> Empresa:
                        </label>

                        <input
                          v-if="isGestorLogged"
                          type="text"
                          class="form-control"
                          :value="loggedCompanyName"
                          readonly
                        />

                        <select
                          v-else
                          id="companySelect"
                          class="form-control"
                          v-model="group.company_id"
                          @change="onCompanyChange"
                        >
                          <option :value="null">Selecione uma empresa</option>
                          <option
                            v-for="company in filteredCompanies"
                            :key="company.id"
                            :value="company.id"
                          >
                            {{ company.name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-2">
                        <label for="unitSelect">
                          Unidades:
                        </label>

                        <v-select
                          id="unitSelect"
                          v-model="group.unit_ids"
                          :options="filteredUnits"
                          :reduce="unit => unit.id"
                          label="name"
                          multiple
                          placeholder="Selecione uma ou mais unidades"
                        />
                      </div>

                      <div class="form-group col-md-1">
                        <label>&nbsp;</label><br />
                        <button
                          type="button"
                          class="btn btn-primary btn-block btn-sm"
                          @click="selectAllUnits"
                          :disabled="allUnitsSelected"
                          title="Selecionar todas as unidades"
                        >
                          <i class="fas fa-check-double"></i> Todas
                        </button>
                      </div>

                      <div class="form-group col-md-2">
                        <label>Status do Grupo</label><br>

                        <toggle-button
                          :sync="true"
                          v-model="statusToggle"
                          color="#15488A"
                          :height="25"
                        />

                        &nbsp;<b>{{ statusToggle ? "Ativo" : "Inativo" }}</b>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>

                    <div class="block text-right">
                      <router-link to="/groups" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>

                      <button type="submit" class="btn btn-add">
                        Salvar
                        <i class="fa fa-save"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>    
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "groupAdd",

  data() {
    return {
      group: {
        group_nome: "",
        company_id: null,
        unit_ids: [],
        status: 1,
      },
      companies: [],
      units: [],
      errors: undefined,
    };
  },

  computed: {
    loggedUser() {
      return this.$store.state.auth?.user || this.$store.state.user || null;
    },

    loggedCompanyName() {
      if (!this.isGestorLogged) {
        return "";
      }

      const company = this.companies.find(
        (company) => Number(company.id) === Number(this.group.company_id)
      );

      return company ? company.name : "";
    },

    isAdminLogged() {
      return Number(this.loggedUser?.perfil_id) === 1;
    },

    isGestorLogged() {
      return Number(this.loggedUser?.perfil_id) === 6;
    },

    isUsuarioPadraoLogged() {
      return Number(this.loggedUser?.perfil_id) === 2;
    },

    filteredCompanies() {
      return this.companies;
    },

    filteredUnits() {
      if (!this.group.company_id) {
        return [];
      }

      return this.units.filter(
        (unit) => Number(unit.company_id) === Number(this.group.company_id)
      );
    },

    allUnitsSelected() {
      if (!this.filteredUnits.length) {
        return true;
      }
      return (
        Array.isArray(this.group.unit_ids) &&
        this.group.unit_ids.length === this.filteredUnits.length
      );
    },

    statusToggle: {
      get() {
        return this.group.status == 1 || this.group.status === true;
      },
      set(value) {
        this.group.status = value ? 1 : 0;
      },
    },
  },

  methods: {
    getLoggedUserCompany() {
      if (!this.loggedUser?.usuario_id) {
        return;
      }

      const api = this.$store.state.api + "users/" + this.loggedUser.usuario_id;

      axios
        .get(api)
        .then((response) => {
          const data = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;

          if (data && data.company_id) {
            this.group.company_id = Number(data.company_id);
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    applyLoggedCompanyToGroup() {
      if (!this.isGestorLogged || !this.loggedUser?.company_id) {
        return;
      }

      this.group.company_id = Number(this.loggedUser.company_id);
    },

    onCompanyChange() {
      this.group.unit_ids = [];
    },

    selectAllUnits() {
      this.group.unit_ids = this.filteredUnits.map(u => u.id);
    },

    makeFormData() {
      this.applyLoggedCompanyToGroup();

      let fd = new FormData();

      fd.append("group_nome", this.group.group_nome || "");
      fd.append("company_id", this.group.company_id || "");

      if (Array.isArray(this.group.unit_ids) && this.group.unit_ids.length > 0) {
        this.group.unit_ids.forEach((id, index) => {
          fd.append(`unit_ids[${index}]`, id);
        });
      }

      fd.append("status", this.group.status);

      if (this.group.id) {
        fd.append("id", this.group.id);
        fd.append("_method", "PUT");
      } else {
        fd.append("_method", "POST");
      }

      return fd;
    },

    save() {
      let api = this.$store.state.api + "groups";
      let fd = this.makeFormData();

      if (this.group.id) {
        api += "/" + this.group.id;
      }

      axios
        .post(api, fd)
        .then(() => {
          this.$message("Sucesso", "Informações guardadas com sucesso", "success");
          this.$router.push("/groups");
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getGroup(id) {
      if (!id || id === "undefined") {
        return;
      }

      const api = this.$store.state.api + "groups/" + id;

      axios
        .get(api)
        .then((response) => {
          const data = response.data.data;
          const groupData = Array.isArray(data) ? data[0] : data;

          if (!groupData) {
            this.$message("Erro", "Grupo não encontrado ou sem permissão", "error");
            this.$router.push("/groups");
            return;
          }

          this.group = {
            ...groupData,
            company_id: groupData.company_id ? Number(groupData.company_id) : null,
            unit_ids: Array.isArray(groupData.units)
              ? groupData.units.map((u) => u.id)
              : [],
            status: groupData.status == 1 || groupData.status === true ? 1 : 0,
          };

          if (this.isGestorLogged) {
            this.applyLoggedCompanyToGroup();
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getCompanies() {
      const api = this.$store.state.api + "companies?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.companies = response.data.data || [];

          if (this.isGestorLogged && this.loggedUser?.company_id) {
            this.group.company_id = Number(this.loggedUser.company_id);
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getUnits() {
      const api = this.$store.state.api + "units?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.units = response.data.data || [];
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },
  },

  components: {
    vSelect,
  },

  mounted() {
    if (this.isUsuarioPadraoLogged) {
      this.$message("Erro", "Você não tem permissão para acessar esta tela", "error");
      this.$router.push("/");
      return;
    }

    this.getCompanies();
    this.getUnits();

    if (this.isGestorLogged) {
      this.getLoggedUserCompany();
      this.applyLoggedCompanyToGroup();
    }

    const id = this.$route.params.id;
    if (id) {
      this.getGroup(id);
    }
  },
};
</script>

<style scoped>
</style>